import { useState, useEffect } from "react";
import { useTransitionState } from "react-transition-state";

const Dropdown = ({ buttonText, children }) => {
    const [open, setOpen] = useState(false);
    const [{ status, isMounted }, toggle] = useTransitionState({
        timeout: 300,
        mountOnEnter: true,
        unmountOnExit: true,
        preEnter: true,
    });

    useEffect(() => {
        toggle(open);
    }, [open, toggle]);

    const mapStatusClasses = (s) => {
        if (!s) return "";
        // map transition-state statuses to the CSS classes used in _dropdown.scss
        switch (s) {
            case "preEnter":
                return "dropdown-enter";
            case "entering":
                return "dropdown-enter dropdown-enter-active";
            case "entered":
                return "dropdown-enter dropdown-enter-active";
            case "preExit":
            case "exiting":
                return "dropdown-exit dropdown-exit-active";
            case "exited":
                return "dropdown-exit";
            default:
                return "";
        }
    };

    return (
        <div className="dropdown-container">
            <button
                className={`dropdown-toggle ${open ? "active" : ""}`}
                onClick={() => setOpen((v) => !v)}
            >
                {buttonText}
            </button>

            {isMounted && (
                <div className={`dropdown-content ${mapStatusClasses(status)}`}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default Dropdown;
